import React, { useRef, useState } from 'react';
import styles from './AgentReverseFeedbackThakyou.module.css'

interface AgentReverseFeedbackThakyou {
    setShowThankYou: any,
}

const AgentReverseFeedbackThakyou: React.FC<AgentReverseFeedbackThakyou> = ({ setShowThankYou }) => {

    return (
        <>
            <div className={styles.AgentReverseFeedbackThakyouWrap}>
                <span className={styles.AgentReverseFeedbackIcon}></span>
                <div className={styles.AgentReverseFeedbackTB}>Request received.</div>
                <div className={styles.AgentReverseFeedbackTn}>Our team will analyze the data and get back to you within 20 days with all the details.</div>
                <div className={styles.AgentReverseFeedbackimpbox}>
                    <span className={styles.AgentReverseLabel}>Important</span>
                    <div className={styles.AgentReverseFeedbackimpboxTxt}>
                    <strong>For accurate results</strong> from Lead Quality 
                    Health Check-up Program, always remember to <strong>update the status</strong> of each lead.
                    </div>
                </div>
            </div>
        </>
    );
};

export default (AgentReverseFeedbackThakyou);
